/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { convertPropToCssClassName } from '@elliemae/ds-classnames';
import { isFunction } from 'lodash-es';

const DOCUMENT = typeof document !== 'undefined' ? document : null;

const blockName = 'portal';

const canRenderPortal = isFunction(ReactDOM.createPortal);

// TODO: If this is rendered on server, is going to break

class DSPortal extends Component {
  // eslint-disable-next-line react/static-property-placement
  static defaultProps = { onRender: () => null };

  constructor(props) {
    super(props);

    this.createPortalContainer = this.createPortalContainer.bind(this);
    this.renderNoPortal = this.renderNoPortal.bind(this);
  }

  // eslint-disable-next-line react/state-in-constructor
  state = { isMounted: false };

  componentDidMount() {
    const { onRender } = this.props;
    this.portalEl = this.createPortalContainer();
    if (DOCUMENT && this.portalEl) {
      DOCUMENT.body.appendChild(this.portalEl);
      onRender();
      this.setState({ isMounted: true });
    }
  }

  componentDidUpdate() {
    if (!canRenderPortal) {
      this.renderNoPortal();
    }
  }

  componentWillUnmount() {
    if (this.portalEl) {
      this.portalEl.parentNode.removeChild(this.portalEl);
    }
  }

  createPortalContainer() {
    if (!DOCUMENT) return null;

    const { className } = this.props;
    const { cssClassName } = convertPropToCssClassName(blockName, className);
    const container = DOCUMENT.createElement('div');
    container.classList.add(cssClassName);
    container.setAttribute('data-testid', 'portal');

    return container;
  }

  renderNoPortal() {
    const { children } = this.props;
    ReactDOM.unstable_renderSubtreeIntoContainer(this, <div>{children}</div>, this.portalEl);
  }

  render() {
    const { children } = this.props;
    const { isMounted } = this.state;
    return !canRenderPortal || !isMounted ? null : ReactDOM.createPortal(children, this.portalEl);
  }
}
export { DSPortal };
export default DSPortal;
